// Stub vide pour site statique - pas d'API backend
// Ce fichier existe uniquement pour éviter les erreurs d'import
// mais ne fait rien car le site est statique

const api = {
  get: () => Promise.reject(new Error('API non disponible sur site statique')),
  post: () => Promise.reject(new Error('API non disponible sur site statique')),
  put: () => Promise.reject(new Error('API non disponible sur site statique')),
  delete: () => Promise.reject(new Error('API non disponible sur site statique')),
};

export default api;
